import { BusinessDataType } from '../context/BusinessContext'
import { FiltersType } from '../context/CommonContext'

const targetsData: FiltersType['targets'] = [
    { id: 1, label: 'Redes Sociais', color: '#F04438' },
    { id: 2, label: 'Indicação', color: '#F79009' },
    { id: 3, label: 'Campanha Google', color: '#12B76A' },
    { id: 4, label: 'Telefonema', color: '#0BA5EC' },
    { id: 5, label: 'Reunião', color: '#F04438' }
]
const creatorsData: FiltersType['creators'] = [
    { id: 1, label: 'John Doe' },
    { id: 2, label: 'Jane Doe' },
    { id: 3, label: 'Bob Smith' },
    { id: 4, label: 'Alice Johnson' },
    { id: 5, label: 'Tom Wilson' }
]
const companiesData: FiltersType['companies'] = [
    {
        id: 1,
        label: 'Celeiro Supermercado'
    },
    {
        id: 2,
        label: 'Brasão Supermercado'
    },
    {
        id: 3,
        label: 'Olimpus Academia'
    },
    {
        id: 4,
        label: 'Tozzo Distribuidora'
    },
    { id: 5, label: 'Hotel Delavy' }
]

const businessData: BusinessDataType = {
    pipelines: [
        {
            id: '1',
            value: 'tab1',
            label: 'Venda',
            steps: [
                {
                    id: '1',
                    title: 'Prospecção',
                    color: '#0BA5EC',
                    business: [
                        {
                            id: '1',
                            title: 'Ligar sem falta',
                            subtitle: 'Joaquim Silva',
                            value: 'R$ 35.000',
                            targets: [
                                {
                                    id: 1,
                                    label: 'Redes Sociais',
                                    color: '#F04438'
                                },
                                {
                                    id: 2,
                                    label: 'Indicação',
                                    color: '#F79009'
                                }
                            ],
                            stepID: '1',
                            dateNotify: '2023-06-01',
                            isExpired: false,
                            professionalID: 1
                        },
                        {
                            id: '2',
                            title: 'Reunião importante',
                            stepID: '1',
                            dateNotify: '2023-06-01',
                            isExpired: false,
                            professionalID: 1
                        },
                        {
                            id: '3',
                            title: 'Transmissão ao Vivo',
                            subtitle: 'Joaquim Silva',
                            value: 'R$ 35.000',
                            targets: [
                                {
                                    id: 1,
                                    label: 'Redes Sociais',
                                    color: '#F04438'
                                }
                            ],
                            stepID: '1',
                            dateNotify: null,
                            isExpired: false,
                            professionalID: 2
                        },
                        {
                            id: '4',
                            title: 'Telefone mudo',
                            subtitle: 'Bento Gonçalves',
                            stepID: '1',
                            dateNotify: null,
                            isExpired: true,
                            professionalID: null
                        }
                    ]
                },
                {
                    id: '2',
                    title: 'Negociação',
                    color: '#FB6514',
                    business: [
                        {
                            id: '1',
                            title: 'Criar Copy',
                            subtitle: 'Joaquim Silva',
                            value: 'R$ 500',
                            stepID: '1',
                            dateNotify: '2025-11-28',
                            isExpired: true,
                            professionalID: 1
                        }
                    ]
                },
                {
                    id: '3',
                    title: 'Finalização',
                    color: '#12B76A',
                    business: [
                        {
                            id: '1',
                            title: 'Enviar contrato',
                            subtitle: 'Joaquim Silva',
                            value: 'R$ 50.000',
                            targets: [
                                {
                                    id: 3,
                                    label: 'Campanha Google',
                                    color: '#12B76A'
                                },
                                {
                                    id: 1,
                                    label: 'Redes Sociais',
                                    color: '#F04438'
                                }
                            ],
                            stepID: '1',
                            dateNotify: '2023-06-01',
                            isExpired: false,
                            professionalID: 2
                        },
                        {
                            id: '2',
                            title: 'Contratar funcionário RH',
                            subtitle: 'Bento Gonçalves',
                            targets: [
                                {
                                    id: 4,
                                    label: 'Telefonema',
                                    color: '#0BA5EC'
                                }
                            ],
                            stepID: '1',
                            dateNotify: '2025-11-14',
                            isExpired: false,
                            professionalID: 1
                        }
                    ]
                }
            ]
        },
        {
            id: '2',
            value: 'tab2',
            label: 'Locação',
            steps: [
                {
                    id: '1',
                    title: 'Negociação',
                    color: '#0BA5EC',
                    business: [
                        {
                            id: '1',
                            title: 'Importante',
                            subtitle: 'Irineu Oliveira',
                            value: 'R$ 22.000',
                            stepID: '1',
                            dateNotify: '2025-12-01',
                            isExpired: false,
                            professionalID: 1
                        }
                    ]
                },
                {
                    id: '2',
                    title: 'Qualificação',
                    color: '#12B76A',
                    business: [
                        {
                            id: '1',
                            title: 'Reunião Europa',
                            subtitle: 'Jucilei Queiroz',
                            value: 'R$ 28.000',
                            stepID: '1',
                            dateNotify: '2025-11-28',
                            isExpired: true,
                            professionalID: 2
                        },
                        {
                            id: '2',
                            title: 'Reunião Manchester City',
                            subtitle: 'Pep Guardiola',
                            value: 'R$ 85.000',
                            stepID: '1',
                            dateNotify: null,
                            isExpired: false,
                            professionalID: null
                        }
                    ]
                }
            ]
        }
    ]
}

export { targetsData, creatorsData, companiesData, businessData }
